// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./cages-container\"></require>\n  <cages-container mooring-id.bind=\"data.mooringId\" review-id.bind=\"data.activeReviewId\"></cages-container>\n</template>\n";
// Exports
export default code;